module.exports = __webpack_public_path__ + "static/media/app-store-fi.894fe300.svg";